module.exports = __webpack_public_path__ + "static/media/firebase.1e018093.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/firebase.svg
// module id = 109
// module chunks = 0